<wdx-badge [themeColor]="themeColor" data-cy="activity-status">
    <div class="d-flex flex-column">
        <div class="d-flex align-items-center align-self-start">
            <span class="text-nowrap" data-cy="lbl-status-tag">{{
                label | translateTokenisedString
            }}</span>
        </div>
    </div>
</wdx-badge>
